export const scenePlasma = `
    vec3 scenePlasma(vec2 uv, float time) {
        uv.x += time * 0.05;
        float v = sin((uv.x*10.)+time) + sin((uv.y*12.)+time*0.5) + sin((uv.x*10.+uv.y*10.)+time);
        v += sin(sqrt(uv.x*uv.x + uv.y*uv.y + 1.0)*10. + time);
        return palette(v*0.2 + time*0.2);
    }
`;
